import React from 'react';
import FlyttstadningBase from './flyttstadning-base';

function FlyttstadningIEskilstuna() {
  return (
    <FlyttstadningBase
      city="Eskilstuna"
      backgroundImage="/images/cleaning/eskilstuna.webp"
      rubrikOne={`Vi hjälper dig med flyttstädning i Eskilstuna, från centrum till Torshälla och omkringliggande områden.`}
      rubrikTwo={`Eskilstuna har en blandning av lägenheter och villor – vi har erfarenhet av båda!`}
      backgroundOpacityClass= "bg-opacity-50"

    />
  );
}

export default FlyttstadningIEskilstuna;
